#@import Backbone
#@import CountdownTimer.Helpers
#@export CountdownTimer.Model

window.CountdownTimer ?= {}

CountdownTimer.Model = Backbone.Model.extend
  timeLeft: ->
    millisLeft = CountdownTimer.Helpers.millisRemaining @get('endAt')
    CountdownTimer.Helpers.timeRemaining millisLeft
